import React from 'react';
import SectionTitle from 'corp/components/UI/SectionTitle';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import OnboardProjectsAction from 'react-scale/corp/views/SensitiveContentUtils/OnboardProjectsAction';
import RemoveSCWorkersAction from 'react-scale/corp/views/SensitiveContentUtils/RemoveSCWorkersAction';
import { IUserJson } from '@scale/shared/types/user';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SensitiveContentUtilsPage: React.FC<{ user: IUserJson }> = ({ user }) => {
  return (
    <div>
      <SectionTitle title="Sensitive Content Utils" />
      <Section name={`Onboard Projects`}>
        <OnboardProjectsAction user={user} />
      </Section>
      <Section name={`Removing Sensitive Content Workers`} forceHidden>
        <RemoveSCWorkersAction user={user} />
      </Section>
    </div>
  );
};

export default SensitiveContentUtilsPage;
